import ApiClient from "./ApiClient";
import SystemNotificator from "@/services/SystemNotificator";
import router from "@/core/router";

function getToken(uuid) {
    return ApiClient.post('/auth/token/' + uuid);
}

function getCode(uuid) {
    return ApiClient.post('/auth/code/' + uuid);
}

function redirectToApp(url, continueUrl)
{
    if (continueUrl) {
        url += '&continue=' + continueUrl
    }
    return window.location.assign(url);
}

function resolveLoginMethod(application) {
    let appType = application.type;

    if (appType === 'dealer_rms' || appType === 'app_factory') {
        return 'oauth2';
    }

    if (application.usesAuthProxy || appType.includes('dealer_dms') || appType.includes('dealer_crm') || appType.includes('agro_crm')) {
        return 'code';
    }

    return 'token';
}

export function grantAccessToApplication(applicationUuid) {
    return ApiClient.post('/application-access/temporary/' + applicationUuid);
}

export function logInToApplication(application, continueUrl, method) {

    if (!application.allowedToAuthenticate) {
        onPermissionDenied(application);
        return;
    }

    let endpoint = application.jwtEndpoint;

    if (!method) {
        method = resolveLoginMethod(application);
    }

    if (method === 'oauth2') {
        window.location.assign((application.secure ? 'https://' : 'http://' ) +  application.domain);
        return;
    }


    if (method === 'code') {
        return getCode(application.uuid)
            .then(({data}) => {
                let code = data.data.code;
                if (application.usesAuthProxy) {
                    let proxyEndpoint = application.authProxyEndpoint;

                    let url = proxyEndpoint + '?code=' + code;
                    if (continueUrl) {
                        url += '&continue=' + continueUrl
                    }
                    return window.location.assign(url);
                }

                redirectToApp(endpoint + '?code=' + code, continueUrl)
            })
    }

    return getToken(application.uuid)
        .then(({data}) => redirectToApp(endpoint + '?id-token=' + data.data.token, continueUrl));
}


export function logInToApplicationByToken(application, continueUrl, token) {

    if (!application.allowedToAuthenticate) {
        onPermissionDenied(application);
        return;
    }


    let endpoint = application.jwtEndpoint;
    let url = endpoint + '?id-token=' + token;
    if (continueUrl) {
        url += '&continue=' + continueUrl
    }
    window.location.replace(url);
}

function onPermissionDenied(application) {
    SystemNotificator.error({title: 'Brak dostępu', message: `Nie posiadasz uprawnień zalogowania się do tej aplikacji ${application.domain} z tego miejsca.`});
    router.push('/')
}

export function logInByIframe(url, code, onLoad) {
    let iframe = document.createElement('iframe');
    iframe.src = url + '?iframe=true&code=' + code;
    iframe.style.display = 'none';
    iframe.onload = function() { onLoad() };
    document.body.appendChild(iframe);
}
